import {RebaseState} from '../../../../hooks/mutations/use-stack-rebase-mutation'
import {type LineTone, LINE_ABOVE_CLASS, LINE_BELOW_CLASS} from '../../../../helpers/stack-entry-line-tone'

// Mirrors `get-effective-entry-line-class` but for the rebasing UI: each
// `RebaseState` maps to a Primer color "tone" that matches its status icon, and
// the vertical timeline line segment between two icons is drawn end-to-end in
// the upper entry's tone. Reuses the tone classes defined in `StackList.module.css`.

const REBASE_STATE_TONE: Record<RebaseState, LineTone> = {
  [RebaseState.Rebasing]: 'attention',
  [RebaseState.Rebased]: 'success',
  [RebaseState.MergeConflicts]: 'danger',
  [RebaseState.FailedToRebase]: 'danger',
  [RebaseState.Skipped]: 'muted',
}

function tone(state?: RebaseState): LineTone {
  return state ? REBASE_STATE_TONE[state] : 'muted'
}

// Returns the className(s) for a rebasing entry's `NavList.Item` so its vertical
// line segments above and below the icon match its (and the previous entry's)
// rebase state. The segment above an icon belongs to the previous (upper) entry
// so the line between two icons reads as one continuous color.
export function getRebaseStateLineClass(state?: RebaseState, previousState?: RebaseState): string {
  const below = tone(state)
  const above = tone(previousState)
  return `${LINE_ABOVE_CLASS[above]} ${LINE_BELOW_CLASS[below]}`
}

// Line color above the base ref item, using the last (closest to trunk) entry.
export function getRebaseStateBaseRefLineClass(states: Array<RebaseState | undefined>): string {
  if (states.length === 0) return ''
  return LINE_ABOVE_CLASS[tone(states[states.length - 1])]
}
